export default "__VITE_ASSET__CAXayKrl__"